import React from 'react'
import Navbar from '../assets/navbar';
import { Navigate } from 'react-router-dom';






export default function ConnectPage() {

  return (
    <>
    <Navbar/>
    <div>ConnectPage Has been embedded in </div>
    </>
  )
}
